export default "__VITE_ASSET__WjNkBjK4__"